import React from "react";

export const AmountInvestedSelectContext = React.createContext();
export const SharesPurchasedSelectContext = React.createContext();

export const AmountInvestedTabContentContext = React.createContext();